'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDivolteScriptUrl = exports.getUrlParams = exports.init = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _getDistinctID = require('./getDistinctID');

var _registerEventsHandler = require('./registerEventsHandler');

var _registerEventsHandler2 = _interopRequireDefault(_registerEventsHandler);

var _utils = require('./utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

// get divolte script url, depends on environment
function getDivolteScriptUrl(options) {
  var defaultOptions = {
    dev: {
      url: 'http://devdivolte.shishike.com/divolte.js',
      validator: function validator() {
        return (/^dev/i.test(location.hostname)
        );
      }
    },
    test: {
      url: 'http://testdivolte.shishike.com/divolte.js',
      validator: function validator() {
        return (/^test/i.test(location.hostname)
        );
      }
    },
    prod: {
      url: 'http://devdivolte.shishike.com/divolte.js',
      validator: function validator() {
        return true;
      }
    }
  };

  var opts = Object.assign({}, defaultOptions, options);
  var env = Object.keys(opts).find(function (item) {
    return opts[item].validator();
  });

  return env ? opts[env].url : null;
}

// get url params
function getUrlParams() {
  var queryString = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : location.search.substr(1);

  var ret = {};

  if (queryString) {
    queryString.split('&').forEach(function (item) {
      var data = item.split('=');
      ret[data[0]] = data[1];
    });
  }

  return ret;
}

// trigger custom events
function triggerCustomEvents(customEvents, defaultParams, e) {
  var eventName = e.eventName,
      content = e.content,
      target = e.target;

  // only 'error' and 'load' events has 'eventName',

  var customEvent = eventName ? { eventName: eventName } : customEvents.find(function (_ref) {
    var xpath = _ref.xpath;

    if (xpath instanceof Array) {
      return xpath.find(function (path) {
        var node = document.querySelector(path);
        return node && node.contains(target);
      });
    } else if (typeof xpath === 'string') {
      var node = document.querySelector(xpath);
      return node && node.contains(target);
    }
    return null;
  });

  if (customEvent && customEvent.eventName) {
    // eslint-disable-next-line no-unused-vars
    var enableDebug = defaultParams.enableDebug,
        excludeEvent = defaultParams.excludeEvent,
        willSendDefaultParams = _objectWithoutProperties(defaultParams, ['enableDebug', 'excludeEvent']);

    var params = Object.assign(content ? _extends({}, content) : {}, willSendDefaultParams, getUrlParams());

    if (target && target.className) {
      params.clickEventSource = target.className;
    }
    if (defaultParams && defaultParams.enableDebug) {
      /* eslint-disable no-console */
      console.group('divolte will send info');
      console.log('customEvent', customEvent);
      console.log('param', params);
      console.groupEnd();
      /* eslint-enable no-console */
    }
    divolte.signal(customEvent.eventName, params);
  }
}

// init, inject a script into document
function init(customEvents) {
  var defaultParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var urlOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  return new Promise(function (resolve, reject) {
    if (!(0, _utils.isArray)(customEvents) || customEvents.length === 0) {
      throw new Error("customEvents must be an array, and please make sure it's not empty!");
    }

    if (!(0, _utils.isPlainObject)(defaultParams)) {
      throw new Error('defaultParams must be an object!');
    }
    Object.assign(defaultParams);

    if (!(0, _utils.isPlainObject)(urlOptions)) {
      throw new Error('urlOptions must be an object!');
    }
    var script = null;
    try {
      script = document.createElement('script');
      script.id = 'divolte-collection';
      script.src = getDivolteScriptUrl(urlOptions);
      script.async = true;
      script.defer = true;
      document.body.appendChild(script);
    } catch (ex) {
      reject(ex);
    }
    // add click event on body, after loaded divolte js file
    script.addEventListener('load', function () {
      if (defaultParams.distinctID) {
        (0, _registerEventsHandler2.default)(triggerCustomEvents.bind(null, customEvents, defaultParams), defaultParams);
        return;
      }

      (0, _getDistinctID.getDistinctID)().then(function (distinctID) {
        Object.assign(defaultParams, {
          distinctID: distinctID
        });
        (0, _registerEventsHandler2.default)(triggerCustomEvents.bind(null, customEvents, defaultParams), defaultParams);
      });

      // release memory
      script = null;
      resolve();
    });

    script.addEventListener('error', function (ex) {
      reject(ex);
    });
  });
}

exports.init = init;
exports.getUrlParams = getUrlParams;
exports.getDivolteScriptUrl = getDivolteScriptUrl;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@kryfe/divolte/es/divolte.js
// module id = 243
// module chunks = 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 35 36 37 38 39 40 41 42 43 44 45 46 47 48 49 50 51 52 53 54 55 56 57 58 59 60 61 62 63 64 65 66 67 68 69 70 71